<template>
  <div v-if="this.location">
    <div id="map" style="width: 234px; height: 232px" ></div>
  </div>
</template>

<script>
import { VUE_GOOGLEMAP_API_KEY } from "@/data/constants";
export default {
  data() {
    return {
      selectedLocation: null,
      map: null,
      marker: null,
      googleMapScriptLoaded: false,
    };
  },

  async mounted() {
    await this.loadGoogleMapScript();
    if (this.location) {
      await this.initializeFromLocation(this.location);
    }
  },

  watch: {
    async location(newLocation) {
      if (newLocation && typeof newLocation === "string") {
        await this.initializeFromLocation(newLocation);
      } else {
        console.warn("⚠️ Ignoring invalid location update:", newLocation);
      }
    },
  },

  props: {
    location: {
      type: String,
      default: "",
    },
  },

  methods: {
    async loadGoogleMapScript() {
      if (this.googleMapScriptLoaded) return;

      return new Promise((resolve, reject) => {
        if (window.google && window.google.maps) {
          this.googleMapScriptLoaded = true;
          resolve();
          return;
        }

        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${VUE_GOOGLEMAP_API_KEY}&libraries=places`;
        script.async = true;
        script.onload = () => {
          this.googleMapScriptLoaded = true;
          resolve();
        };
        script.onerror = reject;

        document.head.appendChild(script);
      });
    },

    async initializeFromLocation(location) {
      if (!location || location === "n/a") return;

      const geocoder = new window.google.maps.Geocoder();
      try {
        const results = await this.geocodeLocation(geocoder, location);
        if (results) {
          const lat = results.geometry.location.lat();
          const lng = results.geometry.location.lng();
          this.renderMap(lat, lng);
        }
      } catch (error) {
        console.error("Geocoding error:", error);
      }
    },

    geocodeLocation(geocoder, address) {
      return new Promise((resolve, reject) => {
        geocoder.geocode({ address }, (results, status) => {
          if (status === window.google.maps.GeocoderStatus.OK) {
            resolve(results[0]);
          } else {
            reject(`Geocode was not successful: ${status}`);
          }
        });
      });
    },

   renderMap(lat, lng) {
  const mapElement = document.getElementById("map");
  if (!mapElement) return;

  this.map = new google.maps.Map(mapElement, {
    center: { lat, lng },
    zoom: 16,
  });

  if (google.maps.marker && google.maps.marker.AdvancedMarkerElement) {
    // Use AdvancedMarkerElement if available
    this.marker = new google.maps.marker.AdvancedMarkerElement({
      position: { lat, lng },
      map: this.map,
    });
  } else {
    console.warn("AdvancedMarkerElement is not available. Falling back to classic Marker.");
    
    // Fallback to classic Marker if AdvancedMarkerElement is not available
    this.marker = new google.maps.Marker({
      position: { lat, lng },
      map: this.map,
    });
  }
}

  },
};

</script>